import { IAppState } from '../../AppModulesWrapper';

export const selectMicrofrontendInitLoadTime = (state: IAppState): number => {
  return state.microfrontend.initLoadTime;
};
